"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7650],{

/***/ 747650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ CollectionCategoryProductWidget1; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
;// CONCATENATED MODULE: ./src/components/DesignSystem/CollectionCategoryProductWidget/CollectionCategorySideRender.js


var CollectionCategorySideRender = function(param) {
    var collectionCategoryString = param.collectionCategoryString, setAccordionId = param.setAccordionId, categoryClickedToBeScrolled = param.categoryClickedToBeScrolled, scrollToCategory = param.scrollToCategory;
    var collections = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            collections: state.catalogReducer.collections
        };
    }).collections;
    var accordionHeaderClick = function(e) {
        e.stopPropagation();
        var dataId = e.currentTarget.getAttribute("data-id");
        if (Number(dataId) === collectionCategoryString.collectionId) {
            setAccordionId(null);
        } else {
            setAccordionId(Number(dataId));
        }
    };
    var calculateOffsetTop = function() {
        var parentElement = document.getElementsByClassName("preHome-page")[0];
        var header = parentElement === null || parentElement === void 0 ? void 0 : parentElement.firstChild;
        return header ? "".concat((header === null || header === void 0 ? void 0 : header.offsetHeight) + 3, "px") || 0 : 0;
    };
    if ((collections === null || collections === void 0 ? void 0 : collections.length) === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "CollectionCategorySideRender",
        style: {
            top: calculateOffsetTop(),
            overflowY: "scroll",
            maxHeight: "calc(100vh - ".concat(calculateOffsetTop(), " )")
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "collection-accordion",
            children: collections === null || collections === void 0 ? void 0 : collections.map(function(collection) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    className: "collection-accordion__container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between collection-accordion__header pointer",
                            "data-id": collection.id,
                            onClick: accordionHeaderClick,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mv0 tw-max-w-[80%]",
                                    style: {
                                        overflow: "scroll",
                                        scrollbarWidth: "none"
                                    },
                                    children: collection.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    alt: "Dropdown button",
                                    style: {
                                        transform: "rotate(".concat(collectionCategoryString.collectionId === collection.id ? "180deg" : "0deg", ")")
                                    },
                                    src: "/assets/images/down-arrow-thin.svg"
                                })
                            ]
                        }),
                        collectionCategoryString.collectionId === collection.id && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "collection-accordion__body",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "body-list",
                                children: collection === null || collection === void 0 ? void 0 : (ref = collection.categories) === null || ref === void 0 ? void 0 : ref.map(function(category) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        id: category.id,
                                        className: "pointer body-list--item ".concat("".concat(collectionCategoryString.collectionId, "-").concat(collectionCategoryString.categoryId) === "".concat(collection.id, "-").concat(category.id) ? "active" : ""),
                                        onClick: function() {
                                            return scrollToCategory("".concat(collection.id, "-").concat(category.id));
                                        },
                                        children: category.name
                                    }, category.id);
                                })
                            })
                        })
                    ]
                }, collection.id);
            })
        })
    });
};

// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/utils/checkClientDeviceType.js
var checkClientDeviceType = __webpack_require__(313508);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductListWrapper/ProductListWrapper.tsx + 1 modules
var ProductListWrapper = __webpack_require__(639996);
// EXTERNAL MODULE: ./src/utils/scrollOnPageLoad.js
var scrollOnPageLoad = __webpack_require__(287243);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./src/components/VirtualisedList/utils.ts
var utils = __webpack_require__(602641);
;// CONCATENATED MODULE: ./src/components/DesignSystem/CollectionCategoryProductWidget/CollectionCategoryProductWidget1.tsx













var CollectionCategoryProductWidget = function() {
    var addCollectionIdCategoryId = function addCollectionIdCategoryId(collectionId, categoryId) {
        var ref, ref1, ref2;
        if (!((ref = prevCollectionIdCategoryId.current) === null || ref === void 0 ? void 0 : (ref1 = ref[collectionId]) === null || ref1 === void 0 ? void 0 : ref1.length)) {
            var ref3;
            prevCollectionIdCategoryId.current[collectionId] = [];
            (ref3 = prevCollectionIdCategoryId.current) === null || ref3 === void 0 ? void 0 : ref3[collectionId].push(categoryId);
            return;
        }
        if ((ref2 = prevCollectionIdCategoryId.current) === null || ref2 === void 0 ? void 0 : ref2[collectionId].find(function(catId) {
            return catId !== categoryId;
        })) {
            var ref4, ref5, ref6;
            if (!((ref4 = prevCollectionIdCategoryId.current) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[collectionId]) === null || ref5 === void 0 ? void 0 : ref5.length)) {
                prevCollectionIdCategoryId.current[collectionId] = [];
            }
            (ref6 = prevCollectionIdCategoryId.current) === null || ref6 === void 0 ? void 0 : ref6[collectionId].push(categoryId);
            return;
        }
        return;
    };
    var checkIfSamePayloadApiAlreadyCalled = function checkIfSamePayloadApiAlreadyCalled(collectionId, categoryId) {
        var ref, ref1, ref2;
        if (!!((ref = prevCollectionIdCategoryId.current) === null || ref === void 0 ? void 0 : (ref1 = ref[collectionId]) === null || ref1 === void 0 ? void 0 : ref1.length) && ((ref2 = prevCollectionIdCategoryId.current) === null || ref2 === void 0 ? void 0 : ref2[collectionId].find(function(catId) {
            return catId === categoryId;
        })) !== undefined) {
            return true;
        }
        return false;
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var prevCollectionIdCategoryId = (0,react.useRef)({});
    var itemsBodyRef = (0,react.useRef)(null);
    var productListWrapperRef = (0,react.useRef)(null);
    var ref = (0,react.useState)({
        collectionId: null,
        categoryId: null
    }), collectionCategoryActive = ref[0], setCollectionCategoryActive = ref[1];
    (0,react.useEffect)(function() {
        var scrollConfig = (0,scrollOnPageLoad/* scrollOnPageLoad */.l)();
        var timeoutValue = undefined;
        if (scrollConfig === null || scrollConfig === void 0 ? void 0 : scrollConfig.toScroll) {
            try {
                var y_scroll = scrollConfig.y_scroll;
                timeoutValue = setTimeout(function() {
                    sessionStorage.removeItem(constants/* CLICKED_ITEM_OBJ */.uI);
                    window.scrollTo({
                        top: y_scroll
                    });
                }, 1100); // arbitrary number to make sure components are properly rendered before scrolling back to previous scroll
            } catch (err) {
                console.log("timeout time error:", err);
            }
        }
        return function() {
            if (timeoutValue) {
                clearTimeout(timeoutValue);
            }
        };
    }, []);
    (0,react.useLayoutEffect)(function() {
        /**
     * setting scrollBehavior to auto as a smooth scroll will trigger all category API calls
     * lying above the intended category leading to UI stuttering when auto scrolling
     */ document.documentElement.style.scrollBehavior = "auto";
    }, []);
    // This ref keeps track of category that's clicked from left section category list.
    var categoryClickedToBeScrolled = (0,react.useRef)(null);
    var ref1 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            collections: state.catalogReducer.collections,
            storeData: state.storeReducer.store
        };
    }), collections = ref1.collections, storeData = ref1.storeData;
    var collectionCatalogItems = (0,es/* useSelector */.v9)(function(state) {
        return {
            collectionCatalogItems: state.catalogReducer.collectionCatalogItems
        };
    }).collectionCatalogItems;
    /**
  * function to provide number of skelton to show while products are loading.
  * this is just a random number
  * there is no boundation, you can change this number when required;
  * 9 -> for 3 rows on mobile
  * 8 -> for 4 rows on desktop
  * @returns
  */ var getSkeletonCount = function() {
        return checkClientDeviceType/* IS_DESKTOP */.yn ? 4 : 8;
    };
    /**
   * flattening data such that it can be easily rendered as a virtualised list in `ProductListWrapper`.
   * actual input output and working can be checked from `flattenCollectionCategoryItems`
   */ var flattenedData = (0,react.useMemo)(function() {
        var flattenData = [];
        flattenData = (0,utils/* flattenCollectionCategoryItems */.k)({
            collectionCatalogItems: collectionCatalogItems,
            collections: collections,
            skeletonCardsCount: getSkeletonCount(),
            collectionObject: function(collection) {
                return {
                    id: collection.id,
                    Component: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            "data-id": collection.id,
                            className: "collection-heading",
                            id: "collection-".concat(collection.id),
                            children: collection.name
                        });
                    },
                    type: "component",
                    intersectionCallback: function() {
                        setCollectionCategoryActive(function(prevState) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                                collectionId: Number(collection === null || collection === void 0 ? void 0 : collection.id)
                            });
                        });
                    }
                };
            },
            categoryObject: function(collection, category) {
                return {
                    id: "".concat(collection.id, "-").concat(category.id),
                    type: "component",
                    Component: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "category-item-header",
                            children: category.name
                        });
                    },
                    intersectionCallback: function intersectionCallback() {
                        setCollectionCategoryActive(function(prevState) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                                categoryId: Number(category === null || category === void 0 ? void 0 : category.id)
                            });
                        });
                        loadMoreData(category, collection);
                    }
                };
            },
            itemObject: function(collection, category, productItem) {
                return {
                    id: "".concat(collection.id, "-").concat(category.id, "-").concat(productItem.id),
                    type: "product-card",
                    data: productItem
                };
            }
        });
        return flattenData;
    }, [
        collections,
        collectionCatalogItems
    ]);
    var loadMoreData = function(category, collection) {
        if ((storeData === null || storeData === void 0 ? void 0 : storeData.store_id) && !checkIfSamePayloadApiAlreadyCalled(collection.id, category.id)) {
            dispatch((0,catalog/* fetchCollectionCatalogItemById */.lA)({
                storeId: storeData.store_id,
                collectionId: collection.id,
                categoryId: category.id
            }));
            addCollectionIdCategoryId(collection.id, category.id);
        }
    };
    var scrollToCategory = function(idToScroll) {
        var ref;
        var indexToScroll = flattenedData === null || flattenedData === void 0 ? void 0 : flattenedData.findIndex(function(dataElement) {
            return (dataElement === null || dataElement === void 0 ? void 0 : dataElement.id) === idToScroll;
        });
        (ref = productListWrapperRef.current) === null || ref === void 0 ? void 0 : ref.scrollToIndex(indexToScroll);
    };
    var setAccordionId = function(id) {
        setCollectionCategoryActive(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                collectionId: id
            });
        });
    };
    var collectionCategoryItemsList = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListWrapper/* ProductListWrapper */.X, {
            ref: productListWrapperRef,
            renderType: "virtualised-grid",
            productList: flattenedData,
            oldCardConfigs: {
                showButton: true,
                noTags: false
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "CollectionCategoryProductWidget1",
        id: "CollectionCategoryProductWidget",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "CollectionCategoryProductWidget1__body !tw-mb-32",
            children: [
                checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "left-section",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionCategorySideRender, {
                        collectionCategoryString: collectionCategoryActive,
                        setAccordionId: function(id) {
                            return setAccordionId(id);
                        },
                        categoryClickedToBeScrolled: categoryClickedToBeScrolled,
                        scrollToCategory: scrollToCategory
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    ref: itemsBodyRef,
                    className: "right-section",
                    children: collectionCategoryItemsList()
                })
            ]
        })
    });
};
/* harmony default export */ var CollectionCategoryProductWidget1 = (CollectionCategoryProductWidget);


/***/ }),

/***/ 287243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ scrollOnPageLoad; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(913886);
/**
 * Checks whether sessionStorage has an item clicked data stored.
 * Then verifies whether the duration between clicked time and returning
 * back to home screen is > 30seconds. Then returns whether session storage
 * contains x and y coordinates of clicked item from PDP section.
 * If the session has those, then return the coordinates else return false.
 * This function is currently being used by Home component on page load.
 */ 
function scrollOnPageLoad() {
    var currTime = new Date();
    var sessionObject = JSON.parse(sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .CLICKED_ITEM_OBJ */ .uI));
    if (sessionObject) {
        var expirationTime = sessionObject === null || sessionObject === void 0 ? void 0 : sessionObject.expiresAt;
        if (expirationTime && Date.parse(currTime) < Date.parse(expirationTime)) {
            var ref, ref1;
            var y_offset = sessionObject === null || sessionObject === void 0 ? void 0 : (ref = sessionObject.itemClickedData) === null || ref === void 0 ? void 0 : ref.CLICKED_ITEM_Y_OFFSET;
            var x_offset = sessionObject === null || sessionObject === void 0 ? void 0 : (ref1 = sessionObject.itemClickedData) === null || ref1 === void 0 ? void 0 : ref1.CLICKED_ITEM_X_OFFSET;
            if (y_offset && y_offset !== 0) {
                return {
                    toScroll: true,
                    x_scroll: x_offset,
                    y_scroll: y_offset
                };
            }
        } else {
            sessionStorage.removeItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .CLICKED_ITEM_OBJ */ .uI);
        }
    }
    return {
        toScroll: false
    };
}


/***/ })

}]);